module.exports = "https://portperrypedals.ca/_res/img/hfy.24f5e47.png";